<template>
    <div class="title_box">
        <div class="line"></div>
        <div class="title">{{title}}</div>
        <div class="line"></div>
    </div>
</template>
<script>
export default {
    name: "MessageTitle",
    props:['title']
}
</script>
<style scoped lang="less">
.title_box{
    display: flex;
    align-items: center;
    height: 40px;
    .line {
        height: 1px;
        background-color: #0095EB;
        flex: 1;
    }
    .title {
        padding: 0 24px;
        color: #0095EB;
        font-size: 26px;
        line-height: 40px;
        position: relative;
        background-color: #fff;
        font-weight: 600;
        &:before {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            left: 0;
            top: 50%;
            margin-top: -5px;
            background-color: #0095EB;
        }
        &:after {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            right: 0;
            top: 50%;
            margin-top: -5px;
            background-color: #0095EB;
        }
    }
}
</style>